module.exports = __webpack_public_path__ + "img/branding_upgrade_after.e7e9c72.png";